import { IEvent } from "../../../components/Events/types"

/**
 * Stable invitation dashboard counts sourced only from the event aggregate
 * fields returned by getEvent. Cards and tabs must use this — never
 * data_uploaded, total_count, or isLoading.
 *
 * failed_contact / failed_system use count_contacts_failed as a stable proxy
 * for the contact bucket until BE exposes explicit split counters.
 */
export function invitationStatsFromEvent(event: IEvent) {
  const waUnsent = event.count_whatsapp_invitations_unsent ?? 0
  const waSent = event.count_whatsapp_invitations_sent ?? 0
  const waDelivered = event.count_whatsapp_invitations_delivered ?? 0
  const waReceived = event.count_whatsapp_invitations_received ?? 0
  const waRead = event.count_whatsapp_invitations_read ?? 0
  const waFailed = event.count_whatsapp_invitations_failed ?? 0

  const whatsappTotal =
    waUnsent + waSent + waDelivered + waReceived + waRead + waFailed
  const deliveryTotal = whatsappTotal || event.count_all_contacts || 0
  const rsvpTotal = event.count_all_contacts || deliveryTotal

  const delivered = waDelivered + waReceived + waRead
  const going = event.count_contacts_going ?? 0
  const declined = event.count_contacts_decline ?? 0
  const invalidRsvp = event.count_contacts_late ?? 0
  const scanned = event.count_contacts_scanned ?? 0

  // WA delivered/read (2,3,4), RSVP not resolved — matches awaiting_reply list filter.
  const awaitingReply =
    delivered > 0 || event.count_contacts_awaiting_reply != null
      ? (event.count_contacts_awaiting_reply ?? 0)
      : (event.count_contacts_waiting ?? 0)

  const failedContact = Math.min(event.count_contacts_failed ?? 0, waFailed)
  const failedSystem = Math.max(0, waFailed - failedContact)

  return {
    waUnsent,
    waSent,
    waDelivered,
    waReceived,
    waRead,
    waFailed,
    delivered,
    inProgress: waSent,
    deliveryTotal,
    rsvpTotal,
    going,
    declined,
    invalidRsvp,
    scanned,
    awaitingReply,
    failedContact,
    failedSystem,
    total: deliveryTotal,
  }
}
